import React, { useState, useCallback, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./cameraOnBoarding.css";
import ChaloButton from "../../../../shared/widgets/chaloButton";
import ChaloTopNav from "../../../../shared/widgets/chaloTopNav";
import { upsertCameraMasterData } from "../../../../services/vehicleMasterService";
import ChaloLoader from "../../../../shared/widgets/chaloLoader";
import { AuthenticationService } from "../../../../services/authorization";
import ChaloAlertDialog from "../../../../shared/widgets/chaloAlertDialog";
import PropTypes from 'prop-types'

const ErrorDialog = ({ heading, message, onClose }) => (
    <div className="error-dialog-container">
        <ChaloAlertDialog heading={heading} message={message} onClose={onClose} />
    </div>
);


ErrorDialog.propTypes = {
  heading: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

const CameraConfirmDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const authService = AuthenticationService.getInstance();
  const parentRoute = authService.getMasterParentRoute();
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorHeading, setErrorHeading] = useState('');

  useEffect(() => {
    if (!data?.cameraId || !data?.cameraBrand) {
      navigate(
        `${parentRoute}/scanCameraQr`
      );
    }
  }, [data, navigate, authService]);



  const closeModal = useCallback(() => {
      setShowModal(false);
      setErrorMessage('');
      setErrorHeading('');
  }, []);

  const addCamera = () => {
    setIsLoading(true);

    const fields = [
      "cameraId",
      "cameraBrand",
      "cameraType",
      "vehicleNo",
      "position",
      "serviceName",
      "liveFeed",
      "ipAddress",
    ];

    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([key]) => fields.includes(key))
    );

    if (Object.hasOwn(filteredData, "liveFeed")) {
      filteredData.isActive = true;
      delete filteredData.liveFeed;
    }


    if (data.simCardInfo?.simICCID) {
      filteredData["simCardNo"] = data.simCardInfo.simICCID;
    }

    filteredData["additionFlow"] = "ONBOARDING";

    upsertCameraMasterData("camera", filteredData, null)
      .then(() => {
        setIsLoading(false);
        const path = `${parentRoute}/cameraSuccess`;

        navigate(path, {
          state: {
            message: "Camera added successfully",
            buttonText: "Okay",
            redirectUrl: "/vehicleMaster/camera",
          },
        });
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorHeading('Error');
        setErrorMessage(err?.description || err?.error || err?.message || 'Something went wrong, please try again.');
        setShowModal(true);
      });
  };

  return (
    <div className="camera-wrapper row">
      {isLoading && <ChaloLoader />}
      <div className="camera-details-container">
        <ChaloTopNav navContent="Confirmation details" />

        <div className="col-md-12 camera-detail-content">
          <div className="passed-message-container">
            <h4>Camera Status</h4>
            <p className={data.cameraConnected ? "Passed" : "failed"}>
              {data.cameraConnected ? "Connected" : "not Connected"}
            </p>
          </div>
          <div className="passed-message-container">
            <h4>RTMP live feed</h4>
            <p className={data.liveFeed ? "Passed" : "failed"}>
              {data.liveFeed ? "Active" : "InActive"}
            </p>
          </div>
          <div className="passed-message-container">
            <h4>SD card check</h4>
            <p
              className={
                data.sdCardInfo?.sdCardPresent
                  ? "Passed"
                  : "failed"
              }
            >
              {data.sdCardInfo?.sdCardPresent
                ? "Passed"
                : "Not Available"}
            </p>
          </div>

          <div className="camera-confirm-form">
            <h4>Camera details</h4>
            <div className="feild-detail">
              <h6>Camera id</h6>
              <p>{data.cameraId || "N/A"}</p>
            </div>
            <div className="feild-detail">
              <h6>Bus number</h6>
              <p>{data.vehicleNo || "N/A"}</p>
            </div>
            <div className="feild-detail">
              <h6>Position</h6>
              <p>{data.position || "N/A"}</p>
            </div>
            <div className="feild-detail">
              <h6>Service name</h6>
              <p>{data.serviceName || "N/A"}</p>
            </div>
            <div className="feild-detail">
              <h6>Camera Brand</h6>
              <p>{data.cameraBrand || "N/A"}</p>
            </div>
            <div className="feild-detail">
              <h6>Camera Type</h6>
              <p>{data.cameraType || "N/A"}</p>
            </div>
            {data.cameraBrand === 'Prama' && (
              <div className="feild-detail">
                <h6>Camera IP Address</h6>
                <p>{data.ipAddress || "N/A"}</p>
              </div>
            )}
          </div>
        </div>

        <div className="col-md-12 live-feed-footer">
          <ChaloButton buttonText="Proceed" onClick={addCamera} />
        </div>
      </div>
      {showModal && (
          <ErrorDialog
              heading={errorHeading}
              message={errorMessage}
              onClose={closeModal}
          />
      )}
    </div>
  );
};

export default CameraConfirmDetails;
